import React, {useContext} from 'react';
import { useTranslation } from 'react-i18next';
import Themes from 'themes';
import './index.css';
const ThemeContext = React.createContext(Themes.themes1);


const Copyright = () => {
  const { t } = useTranslation();
  const Themes = useContext(ThemeContext);
  return(
    <div className="copyright" style={{background: Themes.copyrightBG, color: Themes.color}}>{t('copyright')}</div>
  )
}

export default Copyright
